import React from 'react';
import { API } from '../../../constants';

export default function ProductGalleryMain({ galleryResource, handleOpenLightbox }) {
    return (
        <div className='gallery-main'>
            <div className='gallery-cell pointer' onClick={() => handleOpenLightbox()}>
                <img src={`${API.PRODUCT_IMG_URL}${galleryResource}`} alt={galleryResource} />
            </div>
        </div>
    );
}
